// proformaMobileShared.js — helpers de l'écran « Proforma/Devis » mobile.

const ROOT = "Gestion Commerciale.Ventes.ProformaDevis";
export const PERM = {
  view: `${ROOT}.view`,
  create: `${ROOT}.create`,
  edit: `${ROOT}.edit`,
  delete: `${ROOT}.delete`,
  convert: `${ROOT}.convert`,
};

export const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("fr-FR");
};

/**
 * Le devis n'a pas de statut propre : le desktop le DÉRIVE de `order_status` et
 * `is_converted` (GestionProforma.tsx:2800-2806). Reproduit à l'identique.
 */
export const proformaPill = (record) => {
  if (record.order_status === "Annulé") return { tone: "danger", label: "Annulée" };
  if (record.is_converted) return { tone: "info", label: "Convertie" };
  return { tone: "ok", label: "Active" };
};

export const clientNameOf = (record, clients = []) => {
  if (record.client_name || record.user_name) return record.client_name || record.user_name;
  const client = clients.find((c) => c.id === record.user_id);
  return client?.name || "Client";
};

/**
 * Actions du devis — ternaires exactes des colonnes desktop (l.2839-2896).
 * Les trois sont indépendantes (un devis supprimé n'offre que « restaurer »).
 */
export const actionsFor = (record, can) => ({
  convert:
    can.convert && !record.is_deleted && record.order_status !== "Annulé" && !record.is_converted,
  delete: can.delete && !record.is_deleted && !record.is_converted,
  // Le desktop ne conditionne PAS « Restaurer » à une permission (l.2878).
  restore: Boolean(record.is_deleted),
});
